export const SOFTLINE_FEATURE_DOCUMENTATION = 'documentation';

export const SOFTLINE_PERMISSION_DOCUMENTATION = 'DOKUMENTATION';
